'use strict';

export default class cvEditor {
    constructor(options) {
        this.opt = options;
        this.isCv = options.isCv ? 1 : 0;
        this.bindHandlers();
    }

    bindHandlers() {
        var self = this;

        $('.select2-select').select2({
            language: self.opt.locale
        });

        self.showCheckedJob();

        /**
         * CV files
         */

        $('form[name=uploadNewCvFileForm]').on('change', 'input.uploadNewCvFile', function () {
            $(this.form).submit();
            return false;
        });

        $('form[name=uploadNewCvFileForm]').on('submit', function (e) {

            e.preventDefault();

            $.ajax({
                url: self.opt.uploadFileRoute,
                type: "POST",
                data: new FormData($(this)[0]),
                contentType: false,
                cache: false,
                enctype: 'multipart/form-data',
                processData: false,
                success: function (data) {
                    if (data.success) {
                        $('.uploaded-files').append('<div data-id="' + data.newFileInfo.id + '"><a href="' + data.newFileInfo.path + '" target="_blank">' + data.newFileInfo.name + '</a> <span class="delete-cv-file">delete</span></div>')
                        $('form[name=uploadNewCvFileForm]')[0].reset();
                    } else {
                        alert(data.message);
                    }
                },
                error: function (e) {
                    console.log('error');
                }
            });

            return false;
        });

        $('.uploaded-files').on('click', '.delete-cv-file', function () {
            var fileId = $(this).closest('div').attr('data-id');

            $.ajax({
                url: self.opt.deleteFileRoute,
                type: "POST",
                async: false,
                data: {file: fileId},
                cache: false,
                success: function (data) {
                    if (data.success) {
                        $('.uploaded-files div[data-id=' + fileId + ']').remove();
                    } else {
                        alert(data.message);
                    }
                },
                error: function (e) {
                    console.log('error');
                }
            });
        });

        /**
         * Cv Video
         */

        $('form[name=addCvVideoForm]').on('submit', function (e) {

            e.preventDefault();

            $.ajax({
                url: self.opt.addVideoRoute,
                type: "POST",
                data: new FormData($(this)[0]),
                contentType: false,
                cache: false,
                enctype: 'multipart/form-data',
                processData: false,
                success: function (data) {
                    if (data.success) {
                        $('.added-videos').append('<div data-id="' + data.newVideo.id + '"><a href="' + data.newVideo.video + '" target="_blank">' + data.newVideo.video + '</a> <span class="delete-cv-video">delete</span></div>')
                        $('form[name=addCvVideoForm]')[0].reset();
                        $('.close-modal').trigger('click');
                    } else {
                        alert(data.message);
                    }
                },
                error: function (e) {
                    console.log('error');
                }
            });

            return false;
        });

        $('.added-videos').on('click', '.delete-cv-video', function () {
            var fileId = $(this).closest('div').attr('data-id');

            $.ajax({
                url: self.opt.deleteVideoRoute,
                type: "POST",
                async: false,
                data: {video: fileId},
                cache: false,
                success: function (data) {
                    if (data.success) {
                        $('.added-videos div[data-id=' + fileId + ']').remove();
                    } else {
                        alert(data.message);
                    }
                },
                error: function (e) {
                    console.log('error');
                }
            });
        });

        /**
         * Cv Job
         */
        $(document).on('change', '.job-checkboxes input[type="checkbox"]', function () {
            let value = $(this).val();
            let id = $(this).attr('data-id');
            let name = $(this).attr('name');
            let industry = $(this).attr('data-industry');

            // append and remove selected job block
            if ($(this).is(':checked')) {
                let input = `<input type="hidden" data-id="${id}" data-industry="${industry}" data-name="${name}" name="cv[job][${value + industry}][job]" value="${value}" class="${id}">`;

                $('.checked-input').append(input);
                $('.checked-jobs').append(self.getCheckedJobHtml(id, industry, name));

                // Set the value, creating a new option if necessary
                if ($('#cv_jobInCv').find("option[value='" + value + "']").length) {

                    // get a list of selected values if any - or create an empty array
                    let selectedValues = $('#cv_jobInCv').val();
                    if (selectedValues == null) {
                        selectedValues = new Array();
                    }
                    selectedValues.push(value);   // add the newly created option to the list of selected items
                    $("#cv_jobInCv").val(selectedValues).trigger('change');   // have select2 do it's thing

                    $('.hidden-catalog').fadeOut();
                    $('.hide-catalog-btn').css('display', 'none');
                    $('.show-catalog-btn').css('display', 'flex');
                    $(".job-checkboxes").css('display', 'none');

                    self.fixPlaceholderSelect2(self.opt.placeholderJobSelect2);
                    self.checkActiveCatalogButton();
                }
            } else {
                let wanted_option = $('#cv_jobInCv option[value="'+ value +'"]');
                wanted_option.prop('selected', false);
                $('#cv_jobInCv').trigger('change');
                self.fixPlaceholderSelect2(self.opt.placeholderJobCheckboxes);

                $('.' + id).remove();
            }

            self.checkDisableCheckbox(industry);
        });

        $(document).on('click', '.checked-jobs .delete-checked-job', function () {
            let id = $(this).parent('span').attr('data-id');
            let industry = $(this).parent('span').attr('data-industry');
            $('.' + id).remove();
            $('.job-checkboxes input[data-id=' + id + ']').prop('checked', false);
            self.checkDisableCheckbox(industry);
        });

        /**
         * CV industry
         */
        $(this.opt.jobInCvWrapper).on('click', '.add-new-element-btn', function () {
            self.getSubIndustry($(self.opt.jobInCvWrapper).find('.industry-select').last());
        });

        $(document).on('change', '.industry-select', function () {
            self.getSubIndustry($(this));
        });

        $(document).on('change', '.subIndustry-select', function () {
            if (self.isCv) {
                self.getJobInCV($(this));
            } else {
                self.getJob($(this));
            }
        });

        $(document).ready(function () {
            //if user already selected industry
            //let user possibility to change subIndustry if industry is selected
            if ($('.industry-select').val() !== '') {
                $('.subIndustry-select').attr('disabled', false);
            }

            if ($('.industry-select').val() === '') {
                $('.subIndustry-select').attr('disabled', true);
            }

            //if job field has error => unselect value in industry select
            if ($('.jobInCv-wrapper').find('.form-error:visible').length > 0) {
                $("#cv_industry").val('').change();
            }
        });

        $('.job-select').each(function (k, job) {
            self.getJobIndustryAndSubIndustry($(job))
        });

        $('form[name=cv]').on('change', '.to-current-date  input[type=checkbox]', function () {
            if ($(this).is(':checked')) {
                // $(this).closest('li').find('.section-half.end-date').css('display', 'none');
                $(this).closest('li').find('.section-half.end-date input')[0].defaultValue = null;
                $(this).closest('li').find('.section-half.end-date input').val(null);
            } else {
                // $(this).closest('li').find('.section-half.end-date').css('display', 'inline-block');
                $(this).closest('li').find('.section-half.end-date input')[0].defaultValue = new Date().getMonth()+'-'+new Date().getFullYear();
                $(this).closest('li').find('.section-half.end-date input').val(new Date().getMonth()+'-'+new Date().getFullYear());
            }
        });

        $('#cv_jobInCv').select2({
            placeholder: self.opt.placeholder,
            language: self.opt.locale,
            width: '100%',
            maximumSelectionLength: self.opt.limitSelectJob,
            matcher: function(params, data) {
                return self.matchStart(params, data);
            },
        }).on('select2:select', function (e) {
            let id = $(e.params.data.element).data('id');
            let industry = $(e.params.data.element).data('industry');
            let value = e.params.data.id;

            self.fixPlaceholderSelect2(self.opt.placeholderJobSelect2);

            let input = `<input type="hidden" data-id="${id}" data-industry="${industry}" name="cv[job][${value + industry}][job]" value="${value}" class="${id}">`;
            $('.checked-input').append(input);

            self.checkActiveCatalogButton();
        }).on('select2:unselect', function (e) {
            self.fixPlaceholderSelect2(self.opt.placeholderJobSelect2);
            let id = $(e.params.data.element).data('id');
            $('.' + id).remove();

            $('.show-catalog-btn').css('color', '#674172');
            $('.plus-ico-catalog').removeClass('plus-ico-catalog-inactive');
        });

        self.fixPlaceholderSelect2(self.opt.placeholderJobSelect2);

        $('.industry-select').select2({
            language: self.opt.locale,
        });


        $('.subIndustry-select').select2({
            language: self.opt.locale,
        });

        $(document).mouseup(function (e){
            let div = $(".job-checkboxes");
            if (!div.is(e.target)
                && div.has(e.target).length === 0) {
                div.css('display', 'none');
            }
        });

        $('.show-catalog-btn').on('click', function (e) {
            let count = $('.checked-input input[type="hidden"]').length;
            if (count < self.opt.limitSelectJob) {
                $('.hidden-catalog').addClass('visible-catalog');
                $(this).css('display', 'none');
                $('.hide-catalog-btn').css('display', 'flex');
                self.fixPlaceholderSelect2(self.opt.placeholderJobCheckboxes);
            }
        });

        $('.hide-catalog-btn').on('click', function () {
            $('.hidden-catalog').removeClass('visible-catalog');
            $(this).css('display', 'none');
            $('.show-catalog-btn').css('display', 'flex');
            self.fixPlaceholderSelect2(self.opt.placeholderJobSelect2);
        });

        self.checkActiveCatalogButton();
    }

    matchStart(params, data) {
        params.term = params.term || '';

        if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
            return data;
        }

        return false;
    }

    fixPlaceholderSelect2(placeholder) {
        $('.job-select-block input[type=search]').css('width', '100%').attr('placeholder', placeholder);
    }

    checkActiveCatalogButton() {
        let count = $('.checked-input input[type="hidden"]').length;

        if (count >= this.opt.limitSelectJob) {
            $('.show-catalog-btn').css('color', '#898989');
            $('.plus-ico-catalog').addClass('plus-ico-catalog-inactive');
        }
    }

    showCheckedJob() {
        let self = this;
        let count = $('.checked-input input[type="hidden"]').length;
        if (count === 0) {
            $('.tip-select-job').css('display', 'block');
        }

        $('.checked-input input[type="hidden"]').each(function () {
            let id = $(this).attr('data-id');
            let name = $(this).attr('data-name');
            let industry = $(this).attr('data-industry');

            $('.checked-jobs').append(self.getCheckedJobHtml(id, industry, name));
        })
    }

    getCheckedJobHtml(id, industry, name) {
        return `<span data-id="${id}" data-industry="${industry}" class="${id} checked-element">${name} <a class="delete-checked-job"></a></span>`;
    }

    getJobIndustryAndSubIndustry(select) {
        let id = select.val();
        $.get(this.opt.getIndustryAndSubIndustryPath, {id: id}).done(function (data) {
            let subIndustrySelect = select.parents('li').find('.subIndustry-select');
            let industrySelect = select.parents('li').find('.industry-select');
            industrySelect.find('option[value="' + data.industrySelectedId + '"]').attr('selected', true);
            subIndustrySelect.html(data.options);
        });
    }

    getSubIndustry(select) {
        let id = select.val();
        let subIndustrySelect = $('.subIndustry-select');

        $('.job-checkboxes').remove();

        if (id === '') {
            subIndustrySelect.html("<option>Виберіть значення</option>");
            subIndustrySelect.prop('disabled', true);
            return;
        }
        $.get(this.opt.getSubIndustryPath, {id: id, isCv: this.opt.isCv}).done(function (data) {
            subIndustrySelect.prop('disabled', false);
            subIndustrySelect.html(data.options);
        });
    }

    getJob(select) {
        let id = select.val();
        let self = this;
        $.get(self.opt.getJobPath, {id: id}).done(function (data) {
            select.parents('li').find('#vacancy_job').html(data.options).prop('disabled', false);
        });
    }

    getJobInCV(select) {
        let id = select.val();
        let self = this;
        $.get(self.opt.getJobPath, {id: id, isCv: self.isCv}).done(function (data) {
            $('.jobInCv .tip-select-job').fadeOut();
            $('.job-checkboxes').remove();
            // $('.jobInCv').append(data.options);
            $('.job-select-block').append(data.options);
            $('#cv_jobInCv').html(data.optionsForSelect2);

            //change checked inputs
            $('.checked-input input').each(function (index, element) {
                $('.job-checkboxes input[data-id=' + $(element).attr('data-id') + ']').prop('checked', true);
            });

            let industry = $(data.options).find('input').attr('data-industry');
            self.checkDisableCheckbox(industry);
        });
    }

    checkDisableCheckbox(industry) {
        $('.job-checkboxes').css('display', 'none');
        let checkedAllJobCount = $('.checked-input input').length;
        let checkedIndustryJobCount = $('.checked-input input[data-industry=' + industry + ']').length;

        let showedIndustry = $('.job-checkboxes').find('input').attr('data-industry');
        let showedIndustryJobCount = $('.checked-input input[data-industry=' + showedIndustry + ']').length;

        // It is a magic logic which define unique selected elements of industry in a Job field and check limit it.
        // Add ID industry in object field, if ID is exist it be overvrite
        let objUnique = {};
        $('.checked-input input').each(function (index, element) {
            let id = $(element).attr('data-industry');
            objUnique[id] = true;
        });

        let countUniqueIndustry = Object.keys(objUnique).length;
        if (countUniqueIndustry === 0) {
            countUniqueIndustry = 1;
        }

        // disable checkbox if sum hidden input elements (job) more set limit in config
        if (checkedAllJobCount >= this.opt.limitSelectJob ||
            checkedIndustryJobCount >= this.opt.limitSelectJobInIndustry ||
            countUniqueIndustry >= this.opt.limitSelectIndustry && checkedIndustryJobCount === 0) {
            $('.job-checkboxes input[type="checkbox"]:not(:checked)').prop('disabled', true);

        } else if (checkedAllJobCount < this.opt.limitSelectJob || checkedIndustryJobCount < this.opt.limitSelectJobInIndustry) {
            $('.job-checkboxes input[type="checkbox"][data-industry=' + industry + ']').prop('disabled', false);
        }

        if (countUniqueIndustry < this.opt.limitSelectIndustry &&
            checkedIndustryJobCount === 0 &&
            showedIndustryJobCount < this.opt.limitSelectJobInIndustry) {
            $('.job-checkboxes input[type="checkbox"]').prop('disabled', false);
        }
    }
}